import { createPasswordSchema } from '@worldathletics/utilities';
import { z } from 'zod';

const passwordField = createPasswordSchema();

export const forgotPasswordSchema = z.object({
  email: z.email('Please enter a valid email address.'),
});

export type ForgotPasswordFormValues = z.infer<typeof forgotPasswordSchema>;

export const forgotPasswordDefaultValues: ForgotPasswordFormValues = {
  email: '',
};

export const resetPasswordSchema = z
  .object({
    code: z.string().min(1, 'Verification code is required.'),
    newPassword: passwordField,
    confirmNewPassword: z.string().min(1, 'Please confirm your new password.'),
  })
  .refine(data => data.newPassword === data.confirmNewPassword, {
    message: 'Passwords do not match.',
    path: ['confirmNewPassword'],
  });

export type ResetPasswordFormValues = z.infer<typeof resetPasswordSchema>;

export const resetPasswordDefaultValues: ResetPasswordFormValues = {
  code: '',
  newPassword: '',
  confirmNewPassword: '',
};

export const forceChangePasswordSchema = z
  .object({
    newPassword: passwordField,
    confirmNewPassword: z.string().min(1, 'Please confirm your new password.'),
  })
  .refine(data => data.newPassword === data.confirmNewPassword, {
    message: 'Passwords do not match.',
    path: ['confirmNewPassword'],
  });

export type ForceChangePasswordFormValues = z.infer<
  typeof forceChangePasswordSchema
>;

export const forceChangePasswordDefaultValues: ForceChangePasswordFormValues = {
  newPassword: '',
  confirmNewPassword: '',
};

export const changePasswordSchema = z
  .object({
    oldPassword: z.string().min(1, 'Current password is required.'),
    newPassword: passwordField,
    confirmNewPassword: z.string().min(1, 'Please confirm your new password.'),
  })
  .refine(data => data.newPassword === data.confirmNewPassword, {
    message: 'Passwords do not match.',
    path: ['confirmNewPassword'],
  })
  .refine(data => data.newPassword !== data.oldPassword, {
    message: 'New password must be different from your current password.',
    path: ['newPassword'],
  });

export type ChangePasswordFormValues = z.infer<typeof changePasswordSchema>;

export const changePasswordDefaultValues: ChangePasswordFormValues = {
  oldPassword: '',
  newPassword: '',
  confirmNewPassword: '',
};
